module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"step":"список вопросов для интервью","next":"Далее","lostInfoWarning":"Все изменения будут потеряны. Вы уверены?","continue":"Продолжить редактирование","goBack":"Назад","returnToMaster":"Вернуться в мастер подбора вопросов","returnToTemplates":"Вернуться в мастер выбора шаблона"}}')
  delete Component.options._Ctor
}
